module.exports = __webpack_public_path__ + "gb-sct.svg?c4361672853bbab112bd4b360e6dd199";


//////////////////
// WEBPACK FOOTER
// ./node_modules/flag-icon-css/flags/4x3/gb-sct.svg
// module id = 1461
// module chunks = 0